import { createBlueprint as e } from "@made-people/blueprint";
const a = e({
  slots: {
    base: "lg:max-w-[500px] bg-background-surface-1 rounded-lg p-4 h-full flex flex-col",
    star: "text-black data-[is-active=false]:opacity-30",
    starContainer: "mb-3",
    review: "text-body-sm text-balance mb-auto",
    author: "text-heading-xs mt-3",
    collectedBy: "flex items-center text-label-sm text-text-less-emphasis-2 mt-1"
  },
  variants: {}
});
export {
  a as reviewCardBlueprint
};
//# sourceMappingURL=index-blueprint.es.js.map
